/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAverageOrderValueKpiFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type AverageOrderValueKpi, type ErrorResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/aov
 */
export interface AovRequestBuilder extends BaseRequestBuilder<AovRequestBuilder> {
    /**
     * Averages the order totals of the active orders the organization took in the period — the mean across orders, not across customers, so one large order moves it. It draws on exactly the set of orders that total revenue and orders placed report over the same window, so the three agree. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders reports zero rather than leaving the value absent.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AverageOrderValueKpi>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<AovRequestBuilderGetQueryParameters> | undefined) : Promise<AverageOrderValueKpi | undefined>;
    /**
     * Averages the order totals of the active orders the organization took in the period — the mean across orders, not across customers, so one large order moves it. It draws on exactly the set of orders that total revenue and orders placed report over the same window, so the three agree. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders reports zero rather than leaving the value absent.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<AovRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Averages the order totals of the active orders the organization took in the period — the mean across orders, not across customers, so one large order moves it. It draws on exactly the set of orders that total revenue and orders placed report over the same window, so the three agree. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders reports zero rather than leaving the value absent.
 */
export interface AovRequestBuilderGetQueryParameters {
    /**
     * End of the period, inclusive. Compared against the order date as a full timestamp, so adate with no time stops at midnight; it must not be earlier than the start date.
     */
    endDate?: Date;
    /**
     * Start of the period, inclusive. Compared against the order date as a full timestamp.
     */
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const AovRequestBuilderUriTemplate = "{+baseurl}/api/analytics/aov?endDate={endDate}&startDate={startDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const AovRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AovRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createAverageOrderValueKpiFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
